import React from 'react';
import { GeoJSON } from 'react-leaflet';
import { scenario_a_polygon } from '../data/scenario_a_polygon';

function ScenarioAPolygon() {
  function getFeatureStyle(feature) {
    let color;
    switch (feature.properties.Type) {
      case 'High Ridership Infill':
        color = '#033d01';
        break;
      case 'Targeted/Fringe Infill':
        color = '#268a22';
        break;
      case 'Expansion':
        color = '#a5c77f';
        break;
      default:
        color = '#FFFFFF'; // default color
    }
    return {
      color: color,
      weight: 1.5,
      fillColor: "white",
      fillOpacity: 0,
    };
  }

  // function onEachFeature(feature, layer) {
  //   if (layer.getBounds && feature.properties.number) {
  //     const tooltipContent = `<div style="background-color: white; border: 10px; border-radius: 0px; padding: 0px; font-size: 10px; background-image: none;">${feature.properties.number}</div>`;
  //     layer.bindTooltip(tooltipContent, {
  //       permanent: true,
  //       direction: 'center',
  //       offset: [0, -10],
  //       backgroundColor: 'red',
  //     });
  //   }
  // }

  return (
    <GeoJSON data={scenario_a_polygon} style={getFeatureStyle}  />
  );
}

export default ScenarioAPolygon;
